var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1400px","margin":"20px auto","background-color":"#fff","padding":"30px"},domProps:{"innerHTML":_vm._s(_vm.about_us.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }